<template>
  <h3>Sweets</h3>
  <base-detail :title="'Drinks'">
    <ul>
      <li class="menuList" v-for="item in drinks" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
      <br />
      <h2 class="detailHeading">Sweets</h2>
      <li class="menuList" v-for="item in sweets" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    sweets() {
      const dataList = data.filter((row) => row.mealType === "sweets");
      return dataList;
    },
    drinks() {
      const dataList = data.filter((row) => row.mealType === "drinks");
      return dataList;
    },
  },
};
</script>
